var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{on:{"click":_vm.hideSidebar}},[_c(_vm.tag,_vm._b({tag:"component",staticClass:"nav-link"},'component',_vm.mergedProps,false),[_vm._t("default",function(){return [(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.link.name))])]})],2)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }